import getHelper from '../../../services/getHelper';
import { JobPosting } from '../types';

export default getHelper<JobPosting>('/job-postings/:id', {});
